
const DEFAULT_ROWS_PER_PAGE = 10;
const DEFAULT_ORDER_BY = '__name__'
const DEFAUTL_ORDER_DIRECTION = 'asc'
const DEVICE_TYPE_VALUE = {
    typeAll: 'all',
    typeMissing: 'missing',
    typeLost: 'lost',
    typeDcmd: 'decommissioned',
    typeRcmd: 'recommissioned'
}
const DEVICE_TYPE_STATUS = {
    statusMissing: 'Missing',
    statusLost: 'Lost',
    statusDcmd: 'Decommissioned',
    statusRcmd: 'Recommissioned'
}

export { DEFAULT_ROWS_PER_PAGE, DEFAULT_ORDER_BY, DEFAUTL_ORDER_DIRECTION, DEVICE_TYPE_VALUE, DEVICE_TYPE_STATUS }